import { createColumnHelper } from '@tanstack/react-table';

import { DataTableObject, TableConfigType } from '@/components/PatientDataTable';
import { DETAILS_SIDE_PANEL } from '@/components/PatientDataTable/consts';
import { formatDate, formatLongDateTime, formatContactMethod } from '@/utils';

import { AdminContactLogsResponse } from '../types';

const columnHelper = createColumnHelper<DataTableObject>();

const columns = [
	columnHelper.accessor('patient_identifier', {
		header: () => 'Patient ID',
	}),
	columnHelper.accessor<'created_at', string>('created_at', {
		header: () => 'Date call booked',
		cell: (info) => {
			return formatLongDateTime(info.getValue());
		},
		enableSorting: true,
	}),
	columnHelper.accessor<'scheduled_at', string>('scheduled_at', {
		header: () => 'Call scheduled date',
		cell: (info) => {
			return formatDate(info.getValue());
		},
		enableSorting: true,
	}),
	columnHelper.accessor('study_name', {
		header: () => 'Study name',
	}),
	columnHelper.accessor('contact_method', {
		header: () => 'Contact type',
		cell: (info) => {
			return formatContactMethod(info.getValue());
		},
	}),
];

const rowProps = {
	batchSelect: false,
	onRowClickTarget: {
		baseUrl: DETAILS_SIDE_PANEL,
		rowKey: 'patient',
	},
	rowSelect: true,
	getRowId: (row: DataTableObject) => (row as AdminContactLogsResponse).id,
};

export const clinicalAdminTableConfig: TableConfigType = {
	columns: columns,
	rowProps,
};
